"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasRenderer = void 0;
var preloader_1 = require("../preloader/preloader");
var render_1 = require("./render");
var CanvasRenderer = (function () {
    function CanvasRenderer(container, screen) {
        this.preloader = new preloader_1.Preloader();
        this.container = container;
        this.screen = screen;
    }
    CanvasRenderer.prototype.update = function (scene) {
        var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
        var _this = this;
        var _e = scene.map, base = _e.base, tables = _e.tables, squares = _e.squares;
        var window = this.container.ownerDocument.defaultView;
        var indexSquareMap = {};
        try {
            for (var squares_1 = __values(squares), squares_1_1 = squares_1.next(); !squares_1_1.done; squares_1_1 = squares_1.next()) {
                var square = squares_1_1.value;
                indexSquareMap[square.index] = square;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (squares_1_1 && !squares_1_1.done && (_a = squares_1.return)) _a.call(squares_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var baseSquare = indexSquareMap[base];
        if (baseSquare) {
            this.preloader.loadImage(base, baseSquare.tile.image.src, window);
        }
        try {
            for (var tables_1 = __values(tables), tables_1_1 = tables_1.next(); !tables_1_1.done; tables_1_1 = tables_1.next()) {
                var table = tables_1_1.value;
                try {
                    for (var _f = (e_3 = void 0, __values(table.values())), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var row = _g.value;
                        try {
                            for (var _h = (e_4 = void 0, __values(row.values())), _j = _h.next(); !_j.done; _j = _h.next()) {
                                var index = _j.value;
                                var square = indexSquareMap[index];
                                if (square) {
                                    this.preloader.loadImage(index, square.tile.image.src, window);
                                }
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (_j && !_j.done && (_d = _h.return)) _d.call(_h);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (tables_1_1 && !tables_1_1.done && (_b = tables_1.return)) _b.call(tables_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        if (!this.preloader.loading) {
            this.render(scene);
            return Promise.resolve();
        }
        return new Promise(function (resolve) {
            _this.preloader.subscribe(function () {
                _this.render(scene);
                resolve();
            });
        });
    };
    CanvasRenderer.prototype.render = function (scene) {
        render_1.render(scene, this.container, this.preloader);
    };
    return CanvasRenderer;
}());
exports.CanvasRenderer = CanvasRenderer;
//# sourceMappingURL=canvas-renderer.js.map